/**
 * FieldEditorResolver accepts a field type and returns the appropriate field editor component.
 */

//Import the available editors
import BooleanEditor from "./field-editors/boolean"
import FileEditor from "./field-editors/file"
import TextEditor from "./field-editors/text"
import DateEditor from "./field-editors/date"
import ImageEditor from "./field-editors/image"
import VideoEditor from "./field-editors/video"
import AudioEditor from "./field-editors/audio"
import ArrayEditor from "./field-editors/array"
import ObjectEditor from "./field-editors/object"
import HtmlContentEditor from "./field-editors/html-content"
import DatabaseModelEditor from "./field-editors/database-model"
import ColorTableEditor from "aldoo-ra/Admin/SiteTheme/ColorTableEditor"
import ColorPickerEditor from "./field-editors/color-picker"

//Create a map of field types to their respective editor components
const fieldTypeToEditorMap = {
  Boolean: BooleanEditor,
  File: FileEditor,
  Text: TextEditor,
  Number: TextEditor, // Use TextEditor for number types as well
  Date: DateEditor, // Add mapping for Date type
  DateTime: DateEditor, // Add mapping for DateTime type
  Image: ImageEditor,
  Video: VideoEditor,
  Audio: AudioEditor,
  Object: ObjectEditor,
  Array: ArrayEditor, // Handles both embedded types and CMS content automatically
  ArrayContent: ArrayEditor, // Handles both embedded types and CMS content automatically
  Content: ArrayEditor, // Handles both embedded types and CMS content automatically
  BlogEditor: HtmlContentEditor,
  DateEditor: DateEditor,
  DateRangeEditor: DateEditor,
  DatabaseModel: DatabaseModelEditor,
  ColorTableEditor: ColorTableEditor,
  HtmlEditor: HtmlContentEditor,
  ColorPickerEditor: ColorPickerEditor,
}

// Handle both string type ("Text") and object type ({value: "Text", name: "Text"})
const resolveTypeName = (type) => {
  if (!type) return null
  return typeof type === "object" ? type.value : type
}

/**
 * Get an editor component based on the field type
 * @param {*} type
 */
const getFieldEditor = (field, dataItem, contentType) => {
  //invalid
  if (!field) return
  const { type, fieldEditor, editor } = field
  //the resolved type is the type of the field
  let resolved = resolveTypeName(type)
  // The ArrayEditor handles both CMS content and embedded types internally
  // so we don't need complex resolution logic here
  //if the field has a field editor, use that
  const resolvedFieldEditor = resolveTypeName(fieldEditor)
  if (resolvedFieldEditor && resolvedFieldEditor !== "Default") resolved = resolvedFieldEditor
  //if the field has an editor property, use that (newer convention)
  const resolvedEditor = resolveTypeName(editor)
  if (resolvedEditor && resolvedEditor !== "Default") resolved = resolvedEditor

  //get the component type off the LUT
  return fieldTypeToEditorMap[resolved]
}

/**
 * Check if the field has editor assigned to it
 * @param {*} field
 */
const hasFieldEditor = (field) => {
  return fieldTypeToEditorMap[resolveTypeName(field.type)]
}

/**
 * Set an editor component based on the field type
 * @param {*} type
 * @param {*} editor
 */
const addFieldEditor = (type, editor) => {
  fieldTypeToEditorMap[type] = editor
}

export { getFieldEditor, addFieldEditor, hasFieldEditor }
